import {
    STORAGE_KEY_DYNAMIC_LAST_USER_INFO,
    STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED
} from '../constants/storage';

export function getStorageKey(prefix) {
    return prefix + window.location.origin.replace('https://', '');
}

export const getLastUserInfoStored = () => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_LAST_USER_INFO);
    const dynamicUserLastEbonInfoStored = sessionStorage.getItem(storageKey)
        ? JSON.parse(sessionStorage.getItem(storageKey))
        : {};
    return dynamicUserLastEbonInfoStored ? dynamicUserLastEbonInfoStored : null;
};

export const storeLastUserInfo = (firstname, lastname, phoneNumber) => {
    const storageKey = getStorageKey(STORAGE_KEY_DYNAMIC_LAST_USER_INFO);

    const dynamicUserLastEbonInfoUpdated = {};
    dynamicUserLastEbonInfoUpdated.firstname = firstname;
    dynamicUserLastEbonInfoUpdated.lastname = lastname;
    dynamicUserLastEbonInfoUpdated.phoneNumber = phoneNumber;

    sessionStorage.setItem(storageKey, JSON.stringify(dynamicUserLastEbonInfoUpdated));
};

export const isFailureBankTransferEnabled = () => {
    const storageKey = STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED;
    const isFailureBankTransferEnabled = sessionStorage.getItem(storageKey)
        ? sessionStorage.getItem(storageKey)
        : false;
    return isFailureBankTransferEnabled === 'true';
};



// WEBPACK FOOTER //
// ./src/utils/storageUtils.js